import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";
import { IDS } from "../../IDS";

export const getPerformanceSummary = async () => {
  try {
    return await getData(`/website/performance/summary`);
  } catch (error) {
    console.log(error);
  }
};

export const getHistoryOfOrder = async (name, page, per_page) => {
  try {
    return await getData(
      `/website/performance/history-of-order?name=${name ||
        ""}&page=${page || IDS.PAGE}&per_page=${per_page || IDS.PERPAGE}`
    );
  } catch (error) {
    console.log(error);
  }
};
